
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-we-celebrate",
      function () {
        return require("private-next-pages/how-we-celebrate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-we-celebrate"])
      });
    }
  